import React, { useEffect, Children } from 'react';
import { Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function Portfolio() {
  const {
    t
  } = useLanguage();
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);
  const projects = [{
    img: 'https://cdn.magicpatterns.com/uploads/9cN2qQfwrZRQ1Q45Vgc8KY/hf_20260413_142434_e1a8925e-deb4-4319-bc35-35c5d27a4b75.png',
    label: t.portfolio.labels.residentialCommercial
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/noF32v8CwkqP767TDnzqUH/hf_20260413_135139_37c28768-87d4-42f4-a387-ee353be3f9df_(1).png',
    label: t.portfolio.labels.teamAtWork
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/7Uh8wmQFnnu5ZpNmg17QKP/hf_20260413_140446_530fa841-b076-4eb3-987b-ec818ee54cf9.png',
    label: t.portfolio.labels.interiorPainting
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/x2y2vghnyW3A6UKqUhCtUQ/hf_20260413_141453_6a31fb4f-b49c-47bb-8ed0-118688c96ee0.png',
    label: t.portfolio.labels.exteriorPainting
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/2oAzaTHp68uo4sYHn4pKPV/Captura_de_pantalla_2024-09-11_a_la(s)_11.23.00.png',
    label: t.portfolio.labels.electrical
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/jg8PEp8QPuuDG8YcEjF25E/Errores-Comunes-Al-Remodelar-Una-Casa-Y-Como-Evitarlos-Desde-El-Inicio-.jpg',
    label: t.portfolio.labels.interiorFinish
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/e8rBFYxe21WBGYjYVod7yV/hf_20260413_142639_8d843bdf-e551-4be5-98eb-9f38492ba41b.png',
    label: t.portfolio.labels.commercialResidential
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/xpXUPm85ZhawwG5NGXD5LX/hf_20260413_141409_4b79de60-34b7-4758-ba17-6c4e0e4f0cb8.png',
    label: t.portfolio.labels.roofing
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/nXzxijYwpvyfxHgLUru15f/hf_20260413_135139_37c28768-87d4-42f4-a387-ee353be3f9df_(1).png',
    label: t.portfolio.labels.professionalTeam
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/5CCJSbX6W4jipsELNLVETg/hf_20260413_135303_2a8c0046-eacb-4c81-a33d-c04042bd5082.png',
    label: t.portfolio.labels.residentialProjects
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="portfolio" className="py-24 bg-white" data-id="element-132">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="text-center mb-16" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-brand-black mb-4" data-id="element-135">
            {t.portfolio.title}
          </h2>
          <div className="w-24 h-1.5 bg-brand-red mx-auto rounded-full" data-id="element-136"></div>
        </div>

        <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={controls} className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-137">
          {projects.map((project, index) => <motion.div key={index} variants={itemVariants} className="relative group overflow-hidden rounded-xl shadow-md aspect-square" data-id="element-138">
              <img src={project.img} alt={project.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-139" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-black/90 via-brand-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end" data-id="element-140">
                <div className="p-6 w-full transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-141">
                  <h3 className="text-white font-heading font-bold text-xl" data-id="element-142">
                    {project.label}
                  </h3>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        <div className="mt-16 text-center" data-id="element-143">
          <a href="tel:8324397965" className="inline-flex items-center justify-center gap-2 bg-brand-red text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-red-800 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-144">
            <Phone className="w-5 h-5" data-id="element-145" />
            {t.portfolio.cta}: (832) 439-7965
          </a>
        </div>
      </div>
    </section>;
}